<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div v-if="!showDialogFilters" class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <app-date-time-control-bar
                    @handleFilter="validateDataPreRequest">
                    <template v-slot:selectone>
                        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                            :placeholder="$t('AppAlertsCoaHistorical.Organização')" class="auto-center" :dataKey="'id'" :filter="true"
                            @input="saveChosenOptionsToLocalStorage" style="width: 250px">
                            <template #option="slotProps" style="width: 500px">
                                <div v-if="loadingOrgs"> {{$t('AppAlertsCoaHistorical.Carregando, aguarde')}}</div>
                                <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                    -
                                </div>
                                <div style="padding-right: 20px" v-else>
                                    {{ slotProps.option.display_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </template>
                    <template v-slot:selecttwo>
                        <app-button type="secondary"
                                    class="auto-center"
                                    style="background-color: #0D89EC; margin-left: 10px;"
                                    @handleClick="exportCsv">
                            <i class="pi pi-external-link" />
                            {{$t('AppAlertsCoaHistorical.Exportar')}}
                        </app-button>
                    </template>
                </app-date-time-control-bar>
            </div>
            <div v-if="showDialogFilters" class="kt-portlet__head kt-portlet__head--lg no-border-radius" style="justify-content: center;">
                <app-button v-show="showDialogFilters" type="primary" class="mx-1 auto-center" @handleClick="openMaximizable">
                    {{$t('AppAlertsCoaHistorical.Filtrar')}}
                </app-button>
            </div>
            <Dialog :header="$t('AppAlertsCoaHistorical.Filtrar')" :visible.sync="displayMaximizable" :containerStyle="{width: '85vw'}" :contentStyle="{'overflow': 'visible'}" :maximizable="true" :modal="true">
                <app-date-time-control-bar
                    style="display: flex; justify-content: center; margin-left: 0px;" class="row col-12"
                    @handleFilter="validateDataPreRequest"
                    :is_col_12="true">
                    <template v-slot:selectone>
                        <div class="col-12 row" style="margin-top: 5px;">
                            <label class="col-12">{{$t('AppAlertsCoaHistorical.Organização')}}</label>
                            <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                                :placeholder="$t('AppAlertsCoaHistorical.Organização')" class="auto-center col-12" :dataKey="'id'" :filter="true"
                                @input="saveChosenOptionsToLocalStorage">
                                <template #option="slotProps" style="width: 500px">
                                    <div v-if="loadingOrgs"> {{$t('AppAlertsCoaHistorical.Carregando, aguarde')}}</div>
                                    <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                        -
                                    </div>
                                    <div style="padding-right: 20px" v-else>
                                        {{ slotProps.option.display_name }}
                                    </div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="col-12 row" style="margin-top: 5px;">
                            <label class="col-12">{{$t('AppAlertsCoaHistorical.Período')}}</label>
                        </div>
                    </template>
                </app-date-time-control-bar>
            </Dialog>

            <div class="kt-portlet__body no-padding" id="tableDiv">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" filterDisplay="row" :filters.sync="filters"
                        :sortOrder="-1" sortField="last_alert_time" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll" :expandedRows.sync="expandedRows"
                        :currentPageReportTemplate="$t('AppAlertsCoaHistorical.Mostrando {first} até {last} de {totalRecords} Alertas')"
                        class="p-datatable-striped">

                        <template #header>
                            <span style="font-size: 20px; font-weight: 500;">{{$t('AppAlertsCoaHistorical.Histórico de Alertas')}}</span>
                        </template>
                        <template #empty>
                            {{$t('AppAlertsCoaHistorical.Sem dados para exibir')}}
                        </template>

                        <Column :headerStyle="{'width': '3rem'}">
                            <template #body="slotProps">
                                <span v-if="isRowExpandable(slotProps.data)">
                                    <Button :icon="isRowExpanded(slotProps.data)"
                                            class="p-button-text"
                                            @click="toggleRow(slotProps.data)" />
                                </span>
                            </template>
                        </Column>
                        <Column field="code_alert" :header="$t('AppAlertsCoaHistorical.Código do Alerta')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.code_alert }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Tipo de Alerta')" field="type_alert" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.type_alert }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsAlertTypeCoa"
                                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="criticality_level" :header="$t('AppAlertsCoaHistorical.Criticidade')" headerClass="headerClass" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span :class="'badge criticalityLevel-' + slotProps.data.criticality_level">
                                    {{ getCriticalityLevel(slotProps.data.criticality_level) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsCriticalityLevel"
                                            :placeholder="$t('AppAlertsCoaHistorical.Criticidade')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge criticalityLevel-' + singleValue" style="margin-right: 5px;">
                                            {{ getCriticalityLevel(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge criticalityLevel-' + slotProps.option.code">
                                            {{ getCriticalityLevel(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>
                        <Column field="fleet" :header="$t('AppAlertsCoaHistorical.Frota')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.fleet }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsFleet"
                                            :placeholder="$t('AppAlertsCoaHistorical.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="class_name" :header="$t('AppAlertsCoaHistorical.Classe')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.class_name }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsClass"
                                            :placeholder="$t('AppAlertsCoaHistorical.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="front" :header="$t('AppAlertsCoaHistorical.Frente')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.front }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsFront"
                                            :placeholder="$t('AppAlertsCoaHistorical.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="sensor_name" :header="$t('AppAlertsCoaHistorical.Sensor')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.sensor_name }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsSensorName"
                                            :placeholder="$t('AppAlertsCoaHistorical.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="value_min" :header="$t('AppAlertsCoaHistorical.Min')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.value_min ? formatValue(slotProps.data.value_min) : slotProps.data.value_min }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="alert_value" :header="$t('AppAlertsCoaHistorical.Valor do Alerta')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.alert_value }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="value_max" :header="$t('AppAlertsCoaHistorical.Máx')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.value_max ? formatValue(slotProps.data.value_max) : slotProps.data.value_max }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="message" :header="$t('AppAlertsCoaHistorical.Descrição')" headerClass="headerClass" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.message != null && slotProps.data.message.length > 20" v-tooltip.top="`${slotProps.data.message}`">
                                    {{ slotProps.data.message.slice(0, 20) + ' ...' }}
                                </div>
                                <div v-else>
                                    {{ slotProps.data.message }}
                                </div>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="count" :header="$t('AppAlertsCoaHistorical.Ocorrências')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.count }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_alert_start" :header="$t('AppAlertsCoaHistorical.Data/Hora Início Alerta')" headerClass="headerClass" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_alert_start) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_last_alert_value" :header="$t('AppAlertsCoaHistorical.Data/Hora Última Ocorrência')" headerClass="headerClass" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_last_alert_value) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_alert_end" :header="$t('AppAlertsCoaHistorical.Data/Hora Fim Alerta')" headerClass="headerClass" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_alert_end) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_of_receipt_of_coa" :header="$t('AppAlertsCoa.Data/Hora de Recebimento do COA')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_of_receipt_of_coa) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="duration" :header="$t('AppAlertsCoaHistorical.Duração')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ getTimeFromSecondsDurationFormatMixin(slotProps.data.duration) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="status" :header="$t('AppAlertsCoaHistorical.Status')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span :class="'badge status-' + slotProps.data.status">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsStatus"
                                        :placeholder="$t('AppAlertsCoaHistorical.Selecione')" appendTo="tableDiv"
                                        class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge status-' + singleValue" style="margin-right: 5px;">
                                            {{ getStatus(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge status-' + slotProps.option.code">
                                            {{ getStatus(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>
                        <Column field="user_name" :header="$t('AppAlertsCoaHistorical.Usuário')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.user_name }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '4rem'}" >
                            <template #body="slotProps">
                                <Button icon="pi pi-eye" class="p-button-rounded"
                                    style="margin-right: 5px" @click="handleEdit(slotProps.data)" />
                            </template>
                        </Column>
                        <template #expansion="slotProps">
                            <DataTable :value="slotProps.data.sensor_list" class="p-datatable-striped" stripedRows>
                                <Column field="sensor_name" :header="$t('AppAlertsCoaHistorical.Sensor')" headerClass="headerClass" bodyClass="bodyClass"></Column>
                                <Column :header="$t('AppAlertsCoaHistorical.Regras')" headerClass="headerClass" bodyClass="bodyClass">
                                    <template #body="slotProps">
                                        {{ slotProps.data.rule_first_type }}
                                        {{ slotProps.data.rule_first_value }}
                                        {{ slotProps.data.rule_logical_operator }}
                                        {{ slotProps.data.rule_second_type }}
                                        {{ slotProps.data.rule_second_value }}
                                    </template>
                                </Column>
                                <Column field="alert_value" :header="$t('AppAlertsCoaHistorical.Valor do Alerta')" headerClass="headerClass" bodyClass="bodyClass"></Column>
                            </DataTable>
                        </template>
                    </DataTable>
                </div>

                <Dialog :header="$t('AppAlertsCoaHistorical.Histórico dos Status')" :visible.sync="statusHistorical" :modal="true" :contentStyle="{ 'max-width': '90vw', 'width': '886px' }">
                    <DataTable :value="gridDataHistoricalAlert" :paginator="true" :rows="4" :rowHover="true"
                        :loading="loadingHistoricalAlert" :sortOrder="-1" sortField="last_alert_time" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        responsiveLayout="scroll" style="margin-top: 15px;"
                        :currentPageReportTemplate="$t('AppAlertsCoaHistorical.Mostrando {first} até {last} de {totalRecords} Alertas')"
                        class="p-datatable-striped">

                        <template #empty>
                            {{$t('AppAlertsCoaHistorical.Sem dados para exibir')}}
                        </template>

                        <Column field="user_name" :header="$t('AppAlertsCoaHistorical.Usuário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}"/>
                        <Column field="assignee" :header="$t('AppAlertsCoaHistorical.Responsável')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}" />
                        <Column field="hour" :header="$t('AppAlertsCoaHistorical.Horário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour) }}</span>
                            </template>
                        </Column>
                        <Column field="status" :header="$t('AppAlertsCoaHistorical.Status')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <span :class="'badge status-' + slotProps.data.status">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                        </Column>
                        <Column field="handling" :header="$t('AppAlertsCoaHistorical.Tratativa')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <span :class="'badge handling-' + slotProps.data.handling">
                                    {{ getHandling(slotProps.data.handling) }}
                                </span>
                            </template>
                        </Column>
                        <Column field="comment" :header="$t('AppAlertsCoaHistorical.Comentário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.comment != null && slotProps.data.comment.length > 20" v-tooltip.top="`${slotProps.data.comment}`">
                                    {{ slotProps.data.comment.slice(0, 20) + ' ...' }}
                                </div>
                                <div v-else>
                                    {{ slotProps.data.comment }}
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Dropdown from 'primevue/dropdown';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import AppDateTimeControlBar from "../../../common/AppDateTimeControlBar";
import InputText from 'primevue/inputtext';
import OrganizationsService from "@/services/OrganizationsService";
import AlertsCoaService from '../../../../services/AlertsCoaService';
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import dateHourFormat from "@/mixins/DateMixin";
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";
import MultiSelect from 'primevue/multiselect/MultiSelect';
import AppButton from '../../../common/AppButton.vue';
import Dialog from 'primevue/dialog/Dialog';
import Tooltip from 'primevue/tooltip';
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import VehiclesService from '../../../../services/VehiclesService';
import {STATUSES, CRITICALY_LEVELS, HANDLINGS, ALERT_TYPE} from '../AppOptionsCoa';
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
import Button from 'primevue/button/Button';
import displayToast from '@/mixins/ToastMixin';
import formatValue from '@/mixins/ValuesFormat';
const DATE_FILTER = 'DATE FILTER';
const TS_TO_HOURS = 'TS TO HOURS';

export default {
    mixins: [orderCustomFieldByNaturalOrder, dateHourFormat, getTimeFromSecondsDurationFormatMixin, exportJsonToCsv, displayToast, formatValue],
    created() {
        this.organizationsService = new OrganizationsService();
        this.alertsCoaService = new AlertsCoaService();
        this.vehiclesService = new VehiclesService();
    },
    mounted: function () {
        this.getOrganizations();
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.dateHourFormat(value).includes(filter);
        });
        FilterService.register(TS_TO_HOURS, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.getTimeFromSecondsDurationFormatMixin(value).includes(filter);
        });

        if(window.screen.width <= 1024){
            this.showDialogFilters = true;
        }
    },
    data() {
        return {
            displayMaximizable: false,
            showDialogFilters: false,
            loading: false,
            organizationsService: null,
            vehiclesService: null,
            alertsCoaService: null,
            loadingOrgs: false,
            selectedOrg: null,
            statusHistorical: false,
            gridDataHistoricalAlert: null,
            loadingHistoricalAlert: false,
            organizations: [],
            storedChosenOptions: {},
            gridData: [],
            optionsFleet: [],
            optionsClass: [],
            optionsFront: [],
            optionsSensorName: [],
            optionsHandling: HANDLINGS,
            optionsCriticalityLevel: CRITICALY_LEVELS,
            optionsStatus: STATUSES,
            optionsAlertType: ALERT_TYPE,
            filters: {
                'code_alert': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'type_alert': {value: null, matchMode: FilterMatchMode.IN},
                'criticality_level': {value: null, matchMode: FilterMatchMode.IN},
                'fleet': {value: null, matchMode: FilterMatchMode.IN},
                'class_name': {value: null, matchMode: FilterMatchMode.IN},
                'front': {value: null, matchMode: FilterMatchMode.IN},
                'sensor_name': {value: null, matchMode: FilterMatchMode.IN},
                'value_min': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'alert_value': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'value_max': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'message': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'count': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'hour_alert_start': {value: null, matchMode: DATE_FILTER},
                'hour_last_alert_value': {value: null, matchMode: DATE_FILTER},
                'hour_alert_end': {value: null, matchMode: DATE_FILTER},
                'hour_of_receipt_of_coa': {value: null, matchMode: DATE_FILTER},
                'duration': {value: null, matchMode: TS_TO_HOURS},
                'status': {value: null, matchMode: FilterMatchMode.IN},
                'handling': {value: null, matchMode: FilterMatchMode.IN},
                'user_name': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            expandedRows: [],
            optionsAlertTypeCoa: []
        }
    },
    methods: {
        isRowExpandable(product) {
            return product.sensor_list && product.sensor_list.length > 0;
        },
        isRowExpanded(product) {
            return this.expandedRows.find(e => e.id === product.id) ? 'pi pi-chevron-down' : 'pi pi-chevron-right';
        },
        toggleRow(product) {
            const index = this.expandedRows.indexOf(product);
            if (index !== -1) {
                this.expandedRows.splice(index, 1);
            } else {
                this.expandedRows.push(product);
            }
        },
        handleEdit(val) {
            this.statusHistorical = true;
            this.getStatusHistoricalAlert(val)
        },
        getStatusHistoricalAlert(val){
            this.loadingHistoricalAlert = true
            this.alertsCoaService.getStatusHistoricalAlert(this.selectedOrg.id, val.id).then((data) => {
                this.gridDataHistoricalAlert = data
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaHistorical.Não foi possível buscar os status'), 'e', error)
            }).finally(() => {
                this.loadingHistoricalAlert = false;
            })
        },
        exportCsv(){
            let csvData = [];
            JSON.parse(JSON.stringify(this.gridData)).forEach(data => {
                data.criticality_level = this.getCriticalityLevel(data.criticality_level)
                data.parametric_failures_type = this.getAlertType(data.parametric_failures_type)
                data.status = this.getStatus(data.status)
                csvData.push(data)
            });
            const CSV_FIELDS = [
                'code_alert',
                'type_alert',
                'criticality_level',
                'fleet',
                'class_name',
                'front',
                'sensor_name',
                'value_min',
                'alert_value',
                'value_max',
                'message',
                'count',
                'hour_alert_start',
                'hour_last_alert_value',
                'hour_alert_end',
                'hour_of_receipt_of_coa',
                'duration',
                'status',
                'user_name'
            ]
            const CSV_LABELS = [
                this.$t('AppAlertsCoaHistorical.Código do Alerta'),
                this.$t('AppAlertsCoaHistorical.Tipo de Alerta'),
                this.$t('AppAlertsCoaHistorical.Criticidade'),
                this.$t('AppAlertsCoaHistorical.Frota'),
                this.$t('AppAlertsCoaHistorical.Classe'),
                this.$t('AppAlertsCoaHistorical.Frente'),
                this.$t('AppAlertsCoaHistorical.Sensor'),
                this.$t('AppAlertsCoaHistorical.Min'),
                this.$t('AppAlertsCoaHistorical.Valor do Alerta'),
                this.$t('AppAlertsCoaHistorical.Máx'),
                this.$t('AppAlertsCoaHistorical.Descrição'),
                this.$t('AppAlertsCoaHistorical.Ocorrências'),
                this.$t('AppAlertsCoaHistorical.Data/Hora Início Alerta'),
                this.$t('AppAlertsCoaHistorical.Data/Hora Última Ocorrência'),
                this.$t('AppAlertsCoaHistorical.Data/Hora Fim Alerta'),
                this.$t('AppAlertsCoa.Data/Hora de Recebimento do COA'),
                this.$t('AppAlertsCoaHistorical.Duração'),
                this.$t('AppAlertsCoaHistorical.Status'),
                this.$t('AppAlertsCoaHistorical.Usuário')
            ]
            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, "historical");
        },
        openMaximizable() {
            this.displayMaximizable = true;
        },
        validateDataPreRequest(val){
            this.loading = true
            this.gridData = []
            this.alertsCoaService.getHistoricalAlert(this.selectedOrg.id, moment(val.start_date).unix() * 1000, moment(val.end_date).unix() * 1000).then((data) => {
                data.forEach(element => {
                    this.uniquePush(this.optionsFleet, element.fleet);
                    this.uniquePush(this.optionsClass, element.class_name);
                    this.uniquePush(this.optionsFront, element.front);
                    this.uniquePush(this.optionsSensorName, element.sensor_name);
                    if(element.type_alert === 'simple') {
                        element.alert_value = this.formatValue(element.alert_value) + ' ' + element.unit
                    }

                    if(element.sensor_list) {
                        element.sensor_list.forEach(element => {
                            if(element.alert_value && element.unit){
                                element.alert_value = this.formatValue(element.alert_value) + ' ' + element.unit
                            }
                        });
                    }

                    element.original_type = element.type_alert;
                    element.type_alert = this.$t('AppAlertsCoaAlertsConfig.' + element.type_alert);
                    this.uniquePush(this.optionsAlertTypeCoa, element.type_alert);
                });
                this.expandedRows = []
                this.gridData = data
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaHistorical.Não foi possível buscar os alertas'), 'e', error)
            }).finally(() => {
                this.loading = false;
            })
            this.displayMaximizable = false;
        },
        getOrganizations() {
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaHistorical.Não foi possível buscar organizações'), 'e', error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        getHandling(handling) {
            let result = this.optionsHandling.find(({code}) => code === handling);
            if (result) {
                return result.name;
            }
        },
        getAlertType(alertType) {
            let result = this.optionsAlertType.find(({code}) => code === alertType);
            if (result) {
                return result.name;
            }
        },
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        uniquePush(array, name) {
            if (name != null && name != undefined && array.length === 0) {
                array.push({ code: array.length, name });
                return
            }

            if ((name != null && name != undefined) && !array.some(item => item.name === name)) {
                array.push({ code: array.length, name });
            }
        }
    },
    components: {
        Dropdown,
        DataTable,
        Column,
        MultiSelect,
        InputText,
        AppButton,
        Dialog,
        Button,
        AppDateTimeControlBar,
        Tooltip
    },
    directives: {
        tooltip: Tooltip
    }
}
</script>
<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";

@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
